/* eslint-disable no-use-before-define,no-mixed-operators,no-restricted-globals */
import { show, } from './all'
import { fixURL, safeURL, } from './url'
import { isString, isObject, coalesce, } from './util'

const backFromArgs = {
    '-': { args: 'overview' }
}

export const backFrom = (from) => {
    var loc = from || '-'

    if (loc && isObject(loc) && loc.url) {
        try {
            let a = (new URL(loc.url))
            let isEtrade = a.host.indexOf('etrade.com') >= 0
            let isHome = a.host.indexOf('bonddesk.com') >= 0
                && a.pathname.indexOf('pkg_static.home') >= 0
                && a.search.indexOf('pkg_welcome.output') >= 0

            if (isEtrade || isHome) {
                location.href = loc.url
                return true
            }
        } catch(x) {}

        show('tools', {view:'tools.load-url', url: loc.url})
        return true
    }

    loc = loc==='bond-order' ? 'tools.bond-order' : loc
    let a = backFromArgs[loc] || backFromArgs['-']
    if (loc!=='-') {
        delete backFromArgs[loc]
    }

    setTimeout(() => {
        let args = a.args || {}
        let loc = args.view || 'overview'
        if (!backFromHash(loc)) {
            show(loc, {backFrom:true, ...args})
        }
    }, 1)
    return true
}

export const setBackFrom = (loc, args) => {
    backFromArgs[loc] = {
        ts: Date.now(),
        args: isString(args) ? {view:args} : args
    }
}

export const setLastLoc = (loc) => {
    let args = isString(loc) ? {view:loc} : loc
    backFromArgs['-'] = { args }
}


export const Views = {
    history: [],
    index: 0,
    map: {
        'search-results': 'offerings',
        'tools.bond-portfolio-report': 'portfolio-report'
    },
    enabled: true,
    origin: ''
}

export const setOrigin = (href) => {
    Views.origin = coalesce(
        href,
        fixURL('https://us.etrade.com/etx/hw/v2/accountshome?cnt=header_logon_startin_accounts').toString())
    return Views.origin
}

setOrigin(safeURL(global.location.href).searchParams.get('from'))

export const trackView = (view, args) => {
    if (!Views.enabled) return

    view = args && args.view || view
    view = view==='bond-detail'
        ? 'bond-detail.' + args.cusip
        : view

    let hs = Views.history
    if (hs.length === 50) {
        hs.splice(1,1)
        Views.index = Math.max(Views.index-1,0)
    }

    let cur = hs[Views.index]
    if (cur && cur[0]===view) {
        cur[1] = args
        return
    }

    let i = ++Views.index
    hs[i] = [view, args || {}]
    hs.length = i + 1
}

const isEq = (p, [view, args]) => {
    return p && (p===view || p===args.view)
}

const view = ([view,args]) => {
    Views.viewing = true
    setTimeout(() => { delete Views.viewing })

    Views.enabled = false
    setTimeout(() => { Views.enabled = true }, 200)
    show(view, Object.assign({backFrom:true}, args))
}


export const viewBack = () => {
    if (!Views.enabled) return

    let prev = Views.history[Views.index -1]
    if (!prev) return
    Views.index--
    view(prev)
}

const backFromHash = (hash) => {
    hash = hash[0]==='#' ? hash.slice(1) : hash
    let cur = (Views.map[hash] || hash)
    let prev = Views.history[Views.index - 1]
    if (prev && isEq(cur, prev)) {
        Views.index--
        view(prev)
        return true
    }
}

global.onhashchange = (event) => {
    if (!Views.enabled) return

    let hash = (new URL(event.newURL)).hash.slice(1)
    let cur = (Views.map[hash] || hash)

    let prev = Views.history[Views.index - 1]
    if (prev && isEq(cur, prev)) {
        Views.index--
        view(prev)
        return
    }

    let next = Views.history[Views.index + 1]
    if (next && isEq(cur, next)) {
        Views.index++
        view(next)
        return
    }
}
